// extracted by mini-css-extract-plugin
export default {"slideContainer":"Banner_slideContainer__u93Sr","goTo":"Banner_goTo__trl54"};